import { authApiCall } from "../../../auth";

export const getUserDetails = (id) => {
    // console.log("📋 getUserDetails called with id:", id);
    return authApiCall({
      url: `/users/admin/user-details/${id}/`,
      method: 'get',
    });
  };